
import PostDataComplex from "../../services/PostDataComplex";

const addToFolder = async (image_id, image_name, album_name, album_id, album_usr) => {

  const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
    console.log(`user: ${user}`);
    const token = (JSON.parse(sessionStorage.userData)).user.token;
    console.log(`token: ${token}`);

    const data = {
      user: user,
      token: token,
      image_id: image_id,
      image_name: image_name,
      album_id: album_id,
      album_name: album_name,
    }

    let valueToReturn

    // PostData('POST', 'addToFolder', data)
    await PostDataComplex('albums_manager', 'POST', 'addToFolder', data)
      .then((response) => {
        console.log('addToFolder response.data:->');
        console.log(response.data);

        const addToFolder = response.data.feedBack.addToFolder.addToFolderResult;

        if(addToFolder.imagealbumsassoc) {
          console.log('Images added to folder succesfully!!!');
          console.log(`data.album_id: ${data.album_id}`)
          valueToReturn = data.album_id
          
        } else {
          console.log(addToFolder.error);
          valueToReturn = -1
        }
      }
    )
  
    return valueToReturn

}

export default addToFolder 